import { Route, Switch } from 'react-router-dom';

import { AgedBalance } from './pages/AgedBalance';
import { Overview } from './pages/Overview';

export const Analytics = () => (
  <Switch>
    <Route path="/analytics/aged-balance" component={AgedBalance} />
    <Route path="/analytics" component={Overview} />
  </Switch>
);
